var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 1)?_c('div',{staticClass:"con_but",on:{"click":_vm.chinese_doctor}},[_c('img',{staticClass:"full-width-image",attrs:{"src":require("@/assets/chinese_doctor.png")}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }